import { Nature } from '../Icons/CustomIcons';
import FieldInfo from '../Common/FieldInfo';
import { Checkbox } from './Checkbox';

export const SeasonalActivity = ({
  checked,
  onCheckedChange,
  icon: Icon = Nature,
  iconSize = 24,
  showFieldInfo = false,
  fieldInfoText = '',
}) => (
  <div className="season-field">
    <Checkbox
      id="seasonal-activity"
      checked={checked}
      onCheckedChange={onCheckedChange}
      label={
        <span className="body Font-M-S-130-T Colors-Black seasonal-activity__label">
          <Icon size={iconSize} />
          Saisonale Aktivität
          {showFieldInfo && <FieldInfo text={fieldInfoText} />}
        </span>
      }
    />
  </div>
);